<template>
  <div class="fv-form-inner">
    <div v-if="formTopSrc" style="width: 200px; margin: 0 auto 16px;">
      <img :src="formTopSrc" alt="簡単３０秒入力 無料転職サポート" style="width: 100%;" />
    </div>

    <lp-progress-bar :current-step="currentStep" />

    <div v-if="error" style="margin-bottom: 12px; padding: 8px; background-color: #fef2f2; border: 1px solid #fecaca;">
      <p style="font-size: 12px; color: #b91c1c; white-space: pre-line;">{{ error }}</p>
    </div>

    <component
      :is="currentStepComponent"
      :default-values="formData"
      :is-loading="isLoading"
      @submit="onStepSubmit"
      @back="onStepBack"
    />

    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-box">
        <div class="animate-spin-custom loading-spinner" />
        <p style="margin-top: 16px; color: #333; text-align: center; font-weight: 500;">送信中...</p>
      </div>
    </div>
  </div>
</template>

<script>
import LpProgressBar from './LpProgressBar'
import Step1Form from './steps/Step1Form'
import Step2Form from './steps/Step2Form'
import Step3Form from './steps/Step3Form'
import Step4Form from './steps/Step4Form'
import { submitInquiry } from '../../lib/lp_gym01/api_client'

const STEP_COMPONENTS = {
  1: 'Step1Form',
  2: 'Step2Form',
  3: 'Step3Form',
  4: 'Step4Form'
}

export default {
  name: 'LpMultiStepForm',
  components: { LpProgressBar, Step1Form, Step2Form, Step3Form, Step4Form },
  props: {
    formTopSrc: { type: String, default: '' }
  },
  data () {
    return {
      currentStep: 1,
      formData: {},
      isLoading: false,
      error: null
    }
  },
  computed: {
    currentStepComponent () {
      return STEP_COMPONENTS[this.currentStep]
    },
    isLastStep () {
      return this.currentStep === 4
    }
  },
  methods: {
    onStepSubmit (stepData) {
      var self = this
      self.formData = Object.assign({}, self.formData, stepData)
      self.error = null

      if (!self.isLastStep) {
        self.currentStep++
        return
      }

      self.isLoading = true
      submitInquiry(self.formData)
        .then(function (response) {
          if (response.success && response.inquiry_id) {
            window.location.href = '/lp/gym_01/adding-questions/' + response.inquiry_id
          }
        })
        .catch(function (err) {
          self.error = err.response
            ? (err.response.data.errors || []).join('、') || 'フォームの送信に失敗しました'
            : 'しばらく時間をおいてから再度お試しください'
        })
        .then(function () {
          self.isLoading = false
        })
    },
    onStepBack (currentStepData) {
      this.error = null
      if (currentStepData) this.formData = { ...this.formData, ...currentStepData }
      if (this.currentStep > 1) this.currentStep--
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}
.loading-box {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  max-width: 200px;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}
.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #1877b2;
  border-top-color: transparent;
  border-radius: 50%;
  margin: 0 auto;
}
</style>
